module.exports = __webpack_public_path__ + "img/wait-c.5280ecee.png";